<template>
    <div>
        <v-row no-gutters>
            <v-col cols="4" class="mb-5">
                <h1 class="headline font-weight-light mb-3">Return Part</h1>
            </v-col>
            <v-col cols="8" class="text-right">
                <v-tooltip>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            small
                            :color="
                                chk_export_data == false ? 'green accent-3' : ''
                            "
                            :disabled="chk_export_data == true"
                            class="mr-1 mt-2"
                            @click="export_data2()"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon
                                v-if="chk_export_data == false"
                                color="teal darken-4"
                                >mdi-file-excel</v-icon
                            >
                            <img
                                v-if="chk_export_data == true"
                                src="../../../assets/all/Loading.gif"
                                style="width:6%; "
                            />
                        </v-btn>
                    </template>
                    <span>Export Data</span>
                </v-tooltip>
                <v-btn rounded small class="ml-1 mr-1" @click="get_history()">
                    <v-icon small class="mr-1">mdi-magnify</v-icon>History
                </v-btn>
                <v-btn
                    rounded
                    small
                    :color="checkbox.length > 0 ? 'green accent-3' : 'amber'"
                    @click="get_dialogPreview()"
                >
                    Preview : {{ checkbox.length }}
                </v-btn>
            </v-col>
            <!-- {{ checkbox }} -->
            <BarcodeReader
                class="mar-t-30"
                @barcode="gen_barcode"
                :direction="direction"
            />
        </v-row>

        <div class="mar-t-10 no-pd">
            <v-tabs
                v-model="tab"
                background-color="blue accent-2"
                color="lime accent-2"
                class="elevation-2"
                dark
                :grow="true"
            >
                <v-tabs-slider></v-tabs-slider>

                <v-tab
                    v-for="i in tabs_name.length"
                    :key="i"
                    :href="`#tab-${i}`"
                    @click="change_tab(tabs_name[i - 1])"
                >
                    <v-icon class="mr-1" v-if="tabs_name[i - 1] === actibe_tab"
                        >mdi-checkbox-marked-circle</v-icon
                    >
                    {{ tabs_name[i - 1] }}
                </v-tab>
                <v-tabs-items touchless v-model="tab">
                    <v-tab-item
                        v-for="i in tabs_name.length"
                        :key="i"
                        :value="'tab-' + i"
                    >
                        <div v-if="i === 1">
                            <!-- Search -->
                            <v-row class="mt-5 ml-2">
                                <v-col
                                    cols="11"
                                    sm="5"
                                    md="3"
                                    style="margin-top: -27px"
                                >
                                    <v-select
                                        :items="subproject"
                                        label="Filter"
                                        item-text="project_name"
                                        item-value="project_id"
                                        v-model="send_data.subproject"
                                        @change="get_data()"
                                    ></v-select>
                                </v-col>
                                <v-col
                                    cols="11"
                                    sm="5"
                                    md="3"
                                    style="margin-top: -27px"
                                >
                                    <v-select
                                        :items="select_list"
                                        label="Search by"
                                        v-model="form_search.filter"
                                        @change="change_search()"
                                    ></v-select>
                                </v-col>
                                <v-col cols="11" sm="5" md="3" class="mar-t-10">
                                    <v-text-field
                                        label="Search"
                                        dense
                                        v-model="form_search.search"
                                        @keyup="
                                            change_search($event.target.value)
                                        "
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="1">
                                    <v-btn
                                        x-small
                                        fab
                                        class="mr-1"
                                        v-if="
                                            form_search.filter != 'RMA' ||
                                                form_search.search != ''
                                        "
                                        @click="reset()"
                                    >
                                        <v-icon>mdi-rotate-left</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <!-- Detail -->
                            <div class="mar-t-20">
                                <v-row>
                                    <v-col cols="12">
                                        <v-simple-table class="table-inv">
                                            <template v-slot:default>
                                                <thead>
                                                    <tr class="col-tr-1">
                                                        <th class="text-center">
                                                            <!-- <v-btn
                                                                small
                                                                :color="colorx"
                                                                @click="all()"
                                                                rounded
                                                                >All</v-btn
                                                            > -->
                                                        </th>
                                                        <!-- <th class="text-center">
                                                            #
                                                        </th> -->
                                                        <th class="text-center">
                                                            Cso No.
                                                        </th>
                                                        <th
                                                            width="130px"
                                                            class="text-center"
                                                        >
                                                            Engineer
                                                        </th>
                                                        <th
                                                            width="10px"
                                                            class="text-center"
                                                        >
                                                            Ageing
                                                        </th>
                                                        <th
                                                            width="130px"
                                                            class="text-center"
                                                        >
                                                            Ponumber
                                                        </th>
                                                        <th class="text-center">
                                                            Description
                                                        </th>
                                                        <th class="text-center">
                                                            RMA No.
                                                        </th>
                                                        <th class="text-center">
                                                            Status Part
                                                        </th>
                                                        <th class="text-center">
                                                            LCD / MB
                                                        </th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="(row,
                                                        index) in data_main.data"
                                                        :key="index"
                                                    >
                                                        <td class="text-center">
                                                            <v-switch
                                                                :disabled="
                                                                    chk_chkeckbox(
                                                                        row.project_name,
                                                                        row.ce_status,
                                                                        row.return_box_status
                                                                    )
                                                                "
                                                                @change="
                                                                    selectswitch
                                                                "
                                                                v-model="
                                                                    checkbox
                                                                "
                                                                :value="
                                                                    row.part_issue_id
                                                                "
                                                            ></v-switch>
                                                        </td>
                                                        <!-- <td>
                                                            {{ index + 1 }}.
                                                        </td> -->
                                                        <td class="text-center">
                                                            {{
                                                                row.project_name
                                                            }}
                                                            <br />
                                                            {{ row.case_id }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                row.engineer_name
                                                            }}
                                                            <br />
                                                            {{ row.onsite_at }}
                                                        </td>
                                                        <td
                                                            v-if="
                                                                row.ageing > 5
                                                            "
                                                            style="color: red"
                                                            class="text-center"
                                                        >
                                                            {{ row.ageing }}
                                                        </td>
                                                        <td
                                                            v-else
                                                            class="text-center"
                                                        >
                                                            {{ row.ageing }}
                                                        </td>
                                                        <td>
                                                            {{ row.ponumber }}
                                                        </td>
                                                        <td>
                                                            <span
                                                                class="text-color-red"
                                                            >
                                                                {{
                                                                    row.part_name
                                                                }}
                                                            </span>
                                                            {{
                                                                row.part_description
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{ row.rma }}
                                                        </td>
                                                        <td class="text-center">
                                                            <v-chip
                                                                small
                                                                :color="
                                                                    chk_color(
                                                                        row.ce_status
                                                                    )
                                                                "
                                                            >
                                                                {{
                                                                    row.ce_status
                                                                }}
                                                            </v-chip>
                                                        </td>
                                                        <td class="text-center">
                                                            <v-btn
                                                                x-small
                                                                fab
                                                                class="ml-1"
                                                                color="lime lighten-1"
                                                                target="_blank"
                                                                :to="
                                                                    '/Return-Part/Doc/LCD/' +
                                                                        row.part_issue_id
                                                                "
                                                                >LCD</v-btn
                                                            >
                                                            <v-btn
                                                                class="ml-1"
                                                                x-small
                                                                fab
                                                                color="green darken-1 white--text"
                                                                target="_blank"
                                                                :to="
                                                                    '/Return-Part/Doc/MB/' +
                                                                        row.part_issue_id
                                                                "
                                                                >MB</v-btn
                                                            >
                                                        </td>
                                                        <td class="text-center">
                                                            <div
                                                                v-if="
                                                                    row.ce_status ===
                                                                        'Good' ||
                                                                        row.ce_status ===
                                                                            'DOA'
                                                                "
                                                            >
                                                                <v-btn
                                                                    class="mr-1 mb-1 mt-1"
                                                                    x-small
                                                                    fab
                                                                    color="info"
                                                                    @click="
                                                                        edit(
                                                                            row.case_id,
                                                                            row.ce_status,
                                                                            row.part_issue_id,
                                                                            row.return_box_status,
                                                                            row.return_reason,
                                                                            row.return_remark,
                                                                            row.project_name
                                                                        )
                                                                    "
                                                                >
                                                                    <v-icon
                                                                        small
                                                                        >mdi-pencil</v-icon
                                                                    >
                                                                </v-btn>
                                                                <v-btn
                                                                    :disabled="
                                                                        chk_chkeckbox(
                                                                            row.project_name,
                                                                            row.ce_status,
                                                                            row.return_box_status
                                                                        )
                                                                    "
                                                                    class="mr-1 mb-1 mt-1"
                                                                    x-small
                                                                    fab
                                                                >
                                                                    <!-- @click="print_part(row.part_issue_id)" -->
                                                                    <router-link
                                                                        style="text-decoration: none !important;color: #55637a !important;"
                                                                        target="_blank"
                                                                        :to="
                                                                            row.project_name ==
                                                                            'HPE'
                                                                                ? '/Document/DocDOA/' +
                                                                                  row.part_issue_id
                                                                                : '/Document/DocUnused/' +
                                                                                  row.part_issue_id
                                                                        "
                                                                    >
                                                                        <v-icon
                                                                            >mdi-printer</v-icon
                                                                        ></router-link
                                                                    >
                                                                </v-btn>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                        <hr class="fix-hr-1" />
                                    </v-col>
                                </v-row>
                            </div>
                        </div>

                        <div v-if="i === 2">
                            <!-- Search -->
                            <v-row class="mt-5 ml-2">
                                <v-col
                                    cols="11"
                                    sm="5"
                                    md="3"
                                    style="margin-top: -27px"
                                >
                                    <v-select
                                        :items="subproject"
                                        label="Filter"
                                        item-text="project_name"
                                        item-value="project_id"
                                        v-model="send_data.subproject"
                                        @change="get_data()"
                                    ></v-select>
                                </v-col>
                                <v-col
                                    cols="11"
                                    sm="5"
                                    md="3"
                                    style="margin-top: -27px"
                                >
                                    <v-select
                                        :items="select_list2"
                                        label="Search By"
                                        v-model="form_search.filter"
                                        @change="change_search()"
                                    ></v-select>
                                </v-col>
                                <v-col cols="11" sm="5" md="3" class="mar-t-10">
                                    <v-text-field
                                        label="Search"
                                        dense
                                        v-model="form_search.search"
                                        @keyup="
                                            change_search($event.target.value)
                                        "
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="1">
                                    <v-btn
                                        x-small
                                        fab
                                        class="mr-1"
                                        v-if="
                                            form_search.filter !=
                                                'SinglePart' ||
                                                form_search.search != ''
                                        "
                                        @click="reset()"
                                    >
                                        <v-icon>mdi-rotate-left</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <!-- Detail 1-->
                            <div class="mar-t-20">
                                <h4 class="ml-3 mt-2">NONHP - STOCK @ HQ</h4>

                                <v-row class="mar-t-10">
                                    <v-col cols="12">
                                        <v-simple-table class="table-inv">
                                            <template v-slot:default>
                                                <thead>
                                                    <tr class="col-tr-1">
                                                        <th class="text-center">
                                                            <v-btn
                                                                small
                                                                :color="
                                                                    checkbox.length >
                                                                    0
                                                                        ? colorx
                                                                        : ''
                                                                "
                                                                @click="
                                                                    all_nonhp(1)
                                                                "
                                                                rounded
                                                                >All</v-btn
                                                            >
                                                        </th>
                                                        <th class="text-center">
                                                            #
                                                        </th>
                                                        <th class="text-center">
                                                            Project
                                                        </th>
                                                        <th class="text-center">
                                                            Cso No.
                                                        </th>
                                                        <th class="text-center">
                                                            Date on site
                                                        </th>
                                                        <th class="text-center">
                                                            Ageing
                                                        </th>
                                                        <th class="text-center">
                                                            Description
                                                        </th>
                                                        <th class="text-center">
                                                            SinglePart
                                                        </th>
                                                        <th class="text-center">
                                                            Status Part
                                                        </th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="(row,
                                                        index) in data_main.data"
                                                        :key="index"
                                                    >
                                                        <td class="text-center">
                                                            <v-switch
                                                                :disabled="
                                                                    checkbox_branch.length >
                                                                        0
                                                                "
                                                                v-model="
                                                                    checkbox
                                                                "
                                                                @change="
                                                                    selectswitch
                                                                "
                                                                :value="
                                                                    row.part_issue_id
                                                                "
                                                            ></v-switch>
                                                        </td>
                                                        <td>
                                                            {{ index + 1 }}.
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                row.project_name
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{ row.case_id }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{ row.onsite_at }}
                                                        </td>
                                                        <td
                                                            v-if="
                                                                row.ageing > 5
                                                            "
                                                            style="color: red"
                                                            class="text-center"
                                                        >
                                                            {{ row.ageing }}
                                                        </td>
                                                        <td
                                                            v-else
                                                            class="text-center"
                                                        >
                                                            {{ row.ageing }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                row.part_description
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{ row.singlepart }}
                                                        </td>
                                                        <td class="text-center">
                                                            <v-chip
                                                                small
                                                                :color="
                                                                    chk_color(
                                                                        row.ce_status
                                                                    )
                                                                "
                                                            >
                                                                {{
                                                                    row.ce_status
                                                                }}
                                                            </v-chip>
                                                        </td>
                                                        <td class="text-center">
                                                            <div
                                                                v-if="
                                                                    row.ce_status ===
                                                                        'Good' ||
                                                                        row.ce_status ===
                                                                            'DOA'
                                                                "
                                                            >
                                                                <v-btn
                                                                    class="mr-1 mb-1 mt-1"
                                                                    x-small
                                                                    fab
                                                                    color="info"
                                                                    @click="
                                                                        edit(
                                                                            row.case_id,
                                                                            row.ce_status,
                                                                            row.part_issue_id,
                                                                            row.return_box_status,
                                                                            row.return_reason,
                                                                            row.return_remark
                                                                        )
                                                                    "
                                                                >
                                                                    <v-icon
                                                                        small
                                                                        >mdi-pencil</v-icon
                                                                    >
                                                                </v-btn>
                                                                <v-btn
                                                                    :disabled="
                                                                        chk_chkeckbox(
                                                                            row.project_name,
                                                                            row.ce_status,
                                                                            row.return_box_status
                                                                        )
                                                                    "
                                                                    class="mr-1 mb-1 mt-1"
                                                                    x-small
                                                                    fab
                                                                    @click="
                                                                        print_part(
                                                                            row.part_issue_id
                                                                        )
                                                                    "
                                                                >
                                                                    <v-icon
                                                                        >mdi-printer</v-icon
                                                                    >
                                                                </v-btn>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                        <hr class="fix-hr-1" />
                                    </v-col>
                                </v-row>
                            </div>

                            <!-- Detail 2-->
                            <div
                                v-if="data_main_sub && data_main_sub.length > 0"
                            >
                                <h4 class="ml-3 mt-4">
                                    NONHP - STOCK @ Branch
                                </h4>
                                <v-row class="mar-t-10">
                                    <v-col cols="12">
                                        <v-simple-table class="table-inv">
                                            <template v-slot:default>
                                                <thead>
                                                    <tr class="col-tr-1">
                                                        <th class="text-center">
                                                            <v-btn
                                                                small
                                                                :color="
                                                                    checkbox_branch.length >
                                                                    0
                                                                        ? colorx_branch
                                                                        : ''
                                                                "
                                                                @click="
                                                                    all_nonhp(2)
                                                                "
                                                                rounded
                                                                >All</v-btn
                                                            >
                                                        </th>
                                                        <th class="text-center">
                                                            #
                                                        </th>
                                                        <th class="text-center">
                                                            Project
                                                        </th>
                                                        <th class="text-center">
                                                            Cso No.
                                                        </th>
                                                        <th class="text-center">
                                                            Date on site
                                                        </th>
                                                        <th class="text-center">
                                                            Ageing
                                                        </th>
                                                        <th class="text-center">
                                                            Description
                                                        </th>
                                                        <th class="text-center">
                                                            SinglePart
                                                        </th>
                                                        <th class="text-center">
                                                            Status Part
                                                        </th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="(row_sub,
                                                        index_sub) in data_main_sub"
                                                        :key="index_sub"
                                                    >
                                                        <td class="text-center">
                                                            <v-switch
                                                                :disabled="
                                                                    checkbox.length >
                                                                        0
                                                                "
                                                                v-model="
                                                                    checkbox_branch
                                                                "
                                                                :value="
                                                                    row_sub.part_issue_id
                                                                "
                                                            ></v-switch>
                                                        </td>
                                                        <td>
                                                            {{ index_sub + 1 }}.
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                row_sub.project_name
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                row_sub.case_id
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                row_sub.onsite_at
                                                            }}
                                                        </td>
                                                        <td
                                                            v-if="
                                                                row.ageing > 5
                                                            "
                                                            style="color: red"
                                                            class="text-center"
                                                        >
                                                            {{ row.ageing }}
                                                        </td>
                                                        <td
                                                            v-else
                                                            class="text-center"
                                                        >
                                                            {{ row.ageing }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                row_sub.part_description
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                row_sub.singlepart
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            <v-chip
                                                                small
                                                                :color="
                                                                    chk_color(
                                                                        row_sub.ce_status
                                                                    )
                                                                "
                                                            >
                                                                {{
                                                                    row_sub.ce_status
                                                                }}
                                                            </v-chip>
                                                        </td>
                                                        <td class="text-center">
                                                            <div
                                                                v-if="
                                                                    row_sub.ce_status ===
                                                                        'Good' ||
                                                                        row_sub.ce_status ===
                                                                            'DOA'
                                                                "
                                                            >
                                                                <v-btn
                                                                    class="mr-1 mb-1 mt-1"
                                                                    x-small
                                                                    fab
                                                                    color="info"
                                                                    @click="
                                                                        edit(
                                                                            row_sub.case_id,
                                                                            row_sub.ce_status,
                                                                            row_sub.part_issue_id,
                                                                            row_sub.return_box_status,
                                                                            row_sub.return_reason,
                                                                            row_sub.return_remark
                                                                        )
                                                                    "
                                                                >
                                                                    <v-icon
                                                                        small
                                                                        >mdi-pencil</v-icon
                                                                    >
                                                                </v-btn>
                                                                <v-btn
                                                                    :disabled="
                                                                        chk_chkeckbox(
                                                                            row.project_name,
                                                                            row_sub.ce_status,
                                                                            row_sub.return_box_status
                                                                        )
                                                                    "
                                                                    class="mr-1 mb-1 mt-1"
                                                                    x-small
                                                                    fab
                                                                    @click="
                                                                        print_part(
                                                                            row_sub.part_issue_id
                                                                        )
                                                                    "
                                                                >
                                                                    <v-icon
                                                                        >mdi-printer</v-icon
                                                                    >
                                                                </v-btn>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                        <hr class="fix-hr-1" />
                                    </v-col>
                                </v-row>
                            </div>
                        </div>

                        <v-progress-linear
                            v-if="isLoadPage == true"
                            class="mar-t-10"
                            indeterminate
                            color="cyan"
                        ></v-progress-linear>

                        <div class="text-center pb-5 pt-4">
                            <div>
                                <v-btn
                                    class="mx-2"
                                    fab
                                    small
                                    @click="back()"
                                    :disabled="page_count == 1"
                                >
                                    <v-icon dark>mdi-chevron-left</v-icon>
                                </v-btn>

                                <v-btn
                                    class="mx-2"
                                    fab
                                    small
                                    :color="btn_color(n)"
                                    v-for="n in page_count"
                                    :key="n"
                                    @click="get_data_page(page_num_show(n))"
                                >
                                    {{ page_num_show(n) }}
                                </v-btn>

                                <v-btn class="mx-2" fab small @click="next()">
                                    <v-icon dark>mdi-chevron-right</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </div>

        <!-- MODAL 1 -->
        <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="600px">
                <v-card>
                    <v-form method="post" id="nativeForm" v-model="valid">
                        <v-card-title>
                            <span class="headline"
                                >Case ID {{ form.case_id }}</span
                            >
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row class="mt-3">
                                    <v-col cols="12" class="mar-t-20">
                                        <v-select
                                            v-model="form.box_status"
                                            :rules="box_statusR"
                                            :items="box"
                                            item-text="name"
                                            item-value="id"
                                            label="ลักษณะกล่องที่ได้รับ"
                                            required
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-select
                                            v-model="form.reason"
                                            :items="reason"
                                            item-text="return_detail"
                                            item-value="return_code"
                                            :rules="reasonR"
                                            label="เหตุผล"
                                            required
                                        ></v-select>
                                    </v-col>
                                    <v-col
                                        col="12"
                                        v-if="
                                            form.reason === 'others-1' ||
                                                form.reason === 'others'
                                        "
                                    >
                                        <v-textarea
                                            outlined
                                            v-model="form.remark"
                                            :rules="remarkR"
                                            label="Remark ..."
                                            rows="4"
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close()"
                                >Close</v-btn
                            >
                            <v-btn
                                color="success"
                                @click="save_one_part()"
                                :disabled="!valid"
                                >Save</v-btn
                            >
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
        </v-row>

        <!-- MODAL 2 -->
        <v-row justify="center">
            <v-dialog v-model="dialog2" persistent max-width="600px">
                <v-card>
                    <v-form method="post" id="nativeForm" v-model="valid2">
                        <div v-for="(row, index) in form_data" :key="index">
                            <v-card-title :class="index >= 1 ? 'mar-t-20' : ''">
                                <v-chip
                                    small
                                    :class="
                                        row.status == 'ok'
                                            ? 'green accent-3'
                                            : 'amber'
                                    "
                                    >Case ID {{ row.case_id }}
                                </v-chip>
                                <v-chip class="ml-1 mr-1" small>{{
                                    row.ce_status
                                }}</v-chip>

                                <v-chip small>{{
                                    row.part_name + " " + row.part_description
                                }}</v-chip>

                                <v-chip
                                    class="ml-1"
                                    small
                                    color="red accent-2"
                                    v-if="row.status == 'rejected'"
                                    >Rejected</v-chip
                                >
                            </v-card-title>
                            <v-card-text class="mar-t-10">
                                <v-container>
                                    <v-row v-if="row.status == 'rejected'">
                                        <v-col cols="12">
                                            <v-select
                                                outlined
                                                dense
                                                item-text="name"
                                                item-value="id"
                                                v-model="
                                                    form2[index].return_confirm
                                                "
                                                :rules="return_confirmR"
                                                :items="return_confirm_item"
                                                label="Return Confirm"
                                                required
                                            ></v-select>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-select
                                                outlined
                                                dense
                                                v-model="form2[index].ce_status"
                                                :rules="box_statusR"
                                                :items="['Good', 'Bad', 'DOA']"
                                                label="Status"
                                                required
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            v-if="
                                                form2[index].ce_status ==
                                                    'Good' ||
                                                    form2[index].ce_status ==
                                                        'DOA'
                                            "
                                            class="mar-t-10"
                                        >
                                            <v-select
                                                outlined
                                                dense
                                                v-model="
                                                    form2[index].box_status
                                                "
                                                :rules="box_statusR"
                                                :items="box"
                                                item-text="name"
                                                item-value="id"
                                                label="ลักษณะกล่องที่ได้รับ"
                                                required
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            v-if="
                                                form2[index].ce_status ==
                                                    'Good' ||
                                                    form2[index].ce_status ==
                                                        'DOA'
                                            "
                                            class="mar-t-30"
                                        >
                                            <v-select
                                                outlined
                                                dense
                                                v-model="form2[index].reason"
                                                :items="row.part_status"
                                                item-text="return_detail"
                                                item-value="return_code"
                                                :rules="reasonR"
                                                label="เหตุผล"
                                                required
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                            col="12"
                                            v-if="
                                                row.return_reason ===
                                                    'others-1' ||
                                                    row.return_reason ===
                                                        'others'
                                            "
                                        >
                                            <v-textarea
                                                outlined
                                                dense
                                                v-model="form2[index].remark"
                                                :rules="remarkR"
                                                label="Remark ..."
                                                rows="4"
                                            ></v-textarea>
                                        </v-col>
                                    </v-row>
                                    <v-row
                                        v-if="
                                            (row.ce_status == 'Good' ||
                                                row.ce_status == 'DOA') &&
                                                row.status != 'rejected'
                                        "
                                    >
                                        <v-col cols="12" class="mar-t-10">
                                            <v-select
                                                outlined
                                                dense
                                                v-model="
                                                    form2[index].box_status
                                                "
                                                :rules="box_statusR"
                                                :items="box"
                                                item-text="name"
                                                item-value="id"
                                                label="ลักษณะกล่องที่ได้รับ"
                                                required
                                            ></v-select>
                                        </v-col>
                                        <v-col cols="12" class="mar-t-30">
                                            <v-select
                                                outlined
                                                dense
                                                v-model="form2[index].reason"
                                                :items="row.part_status"
                                                item-text="return_detail"
                                                item-value="return_code"
                                                :rules="reasonR"
                                                label="เหตุผล"
                                                required
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                            col="12"
                                            v-if="
                                                row.return_reason ===
                                                    'others-1' ||
                                                    row.return_reason ===
                                                        'others'
                                            "
                                        >
                                            <v-textarea
                                                outlined
                                                dense
                                                v-model="form2[index].remark"
                                                :rules="remarkR"
                                                label="Remark ..."
                                                rows="4"
                                            ></v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                        </div>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close2()"
                                >Close</v-btn
                            >
                            <v-btn
                                color="success"
                                @click="save_form_part()"
                                :disabled="!valid2"
                                >Save</v-btn
                            >
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
        </v-row>

        <!-- snackbar -->
        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" :color="colorSnac" right>{{
                text
            }}</v-snackbar>
        </div>

        <v-row justify="center">
            <v-dialog
                v-model="dialog_search"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="dialog_search = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>
                            <!-- Settings -->
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <!-- <v-toolbar-items>
                            <v-btn dark text @click="dialog = false"
                                >Save</v-btn
                            >
            </v-toolbar-items>-->
                    </v-toolbar>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="3">
                                <v-text-field
                                    label="Search"
                                    v-model="data_search.search"
                                    prepend-inner-icon="mdi-magnify"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-menu
                                    v-model="modal"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="dateRangeText"
                                            label="Date range"
                                            dense
                                            prepend-inner-icon="mdi-calendar"
                                            readonly
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="data_search.date"
                                        range
                                        @change="get_date()"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col
                                cols="2"
                                class="text-right"
                                v-if="checkbox.length == 0"
                            >
                                <v-btn
                                    rounded
                                    small
                                    class="ml-5"
                                    @click="get_history()"
                                >
                                    <v-icon small class="mr-1"
                                        >mdi-magnify</v-icon
                                    >Search
                                </v-btn>
                            </v-col>

                            <v-tooltip left v-if="data_search.date.length == 2">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        fab
                                        small
                                        :color="
                                            chk_export_data == false
                                                ? 'green accent-3'
                                                : ''
                                        "
                                        :disabled="chk_export_data == true"
                                        class="mr-1 mt-2"
                                        @click="export_data()"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon
                                            v-if="chk_export_data == false"
                                            color="teal darken-4"
                                            >mdi-file-excel</v-icon
                                        >
                                        <img
                                            v-if="chk_export_data == true"
                                            src="../../../assets/all/Loading.gif"
                                            style="width:6%; "
                                        />
                                    </v-btn>
                                </template>
                                <span>Export Data</span>
                            </v-tooltip>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <v-simple-table class="table-inv">
                                    <template v-slot:default>
                                        <thead>
                                            <tr class="col-tr-1">
                                                <th class="text-center">
                                                    #
                                                </th>
                                                <th class="text-center">
                                                    Cso No.
                                                </th>
                                                <th class="text-center">
                                                    Date on site
                                                </th>
                                                <th class="text-center">
                                                    Ageing
                                                </th>
                                                <th class="text-center">
                                                    Description
                                                </th>
                                                <th class="text-center">
                                                    RMA No.
                                                </th>
                                                <th class="text-center">
                                                    Status Part
                                                </th>
                                                <th class="text-center">
                                                    Return
                                                </th>
                                                <th class="text-center">
                                                    ใบ Return
                                                </th>
                                                <th class="text-center">
                                                    LCD / MB
                                                </th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="(row,
                                                index) in data_history"
                                                :key="index"
                                            >
                                                <td>{{ index + 1 }}.</td>
                                                <td class="text-center">
                                                    {{ row.case_id }}
                                                </td>
                                                <td class="text-center">
                                                    {{ row.onsite_at }}
                                                </td>
                                                <td
                                                    v-if="row.ageing > 5"
                                                    style="color: red"
                                                    class="text-center"
                                                >
                                                    {{ row.ageing }}
                                                </td>
                                                <td v-else class="text-center">
                                                    {{ row.ageing }}
                                                </td>
                                                <td>
                                                    {{ row.part_description }}
                                                </td>
                                                <td class="text-center">
                                                    {{ row.rma }}
                                                </td>
                                                <td class="text-center">
                                                    <v-chip
                                                        small
                                                        :color="
                                                            chk_color(
                                                                row.ce_status
                                                            )
                                                        "
                                                    >
                                                        {{ row.ce_status }}
                                                    </v-chip>
                                                </td>
                                                <td class="text-center">
                                                    {{ row.ce_return_by }}
                                                    <br />
                                                    <v-chip small>
                                                        {{ row.ce_return_date }}
                                                    </v-chip>
                                                </td>
                                                <td class="text-center">
                                                    <!-- DocReturn_url -->
                                                    <v-btn
                                                        class="mr-1 mb-1 mt-1"
                                                        small
                                                        rounded
                                                    >
                                                        <router-link
                                                            style="
                                    text-decoration: none !important;
                                    color: #55637a !important;
                                  "
                                                            target="_blank"
                                                            :to="
                                                                DocReturn_url +
                                                                    row.return_no
                                                            "
                                                        >
                                                            <v-icon
                                                                >mdi-printer</v-icon
                                                            >ใบ Return
                                                        </router-link>
                                                    </v-btn>
                                                </td>
                                                <td class="text-center">
                                                    <v-btn
                                                        x-small
                                                        fab
                                                        class="ml-1"
                                                        color="lime lighten-1"
                                                        target="_blank"
                                                        :to="
                                                            '/Return-Part/Doc/LCD/' +
                                                                row.part_issue_id
                                                        "
                                                        >LCD</v-btn
                                                    >
                                                    <v-btn
                                                        class="ml-1"
                                                        x-small
                                                        fab
                                                        color="green darken-1 white--text"
                                                        target="_blank"
                                                        :to="
                                                            '/Return-Part/Doc/MB/' +
                                                                row.part_issue_id
                                                        "
                                                        >MB</v-btn
                                                    >
                                                </td>
                                                <td class="text-center">
                                                    <div
                                                        v-if="
                                                            row.ce_status ===
                                                                'Good' ||
                                                                row.ce_status ===
                                                                    'DOA'
                                                        "
                                                    >
                                                        <v-btn
                                                            :disabled="
                                                                chk_chkeckbox(
                                                                    row.project_name,
                                                                    row.ce_status,
                                                                    row.return_box_status
                                                                )
                                                            "
                                                            class="mr-1 mb-1 mt-1"
                                                            small
                                                            :color="
                                                                chk_color(
                                                                    row.ce_status
                                                                )
                                                            "
                                                            rounded
                                                        >
                                                            <router-link
                                                                style="text-decoration: none !important;color: #55637a !important;"
                                                                target="_blank"
                                                                :to="
                                                                    '/Document/DocUnused/' +
                                                                        row.part_issue_id
                                                                "
                                                            >
                                                                <v-icon
                                                                    >mdi-printer</v-icon
                                                                >
                                                                ใบ
                                                                {{
                                                                    row.ce_status
                                                                }}
                                                            </router-link>
                                                        </v-btn>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>

        <!-- dialogPreview -->
        <v-row justify="center">
            <v-dialog
                v-model="dialogPreview"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card tile>
                    <v-toolbar flat dark color="primary">
                        <v-btn icon dark @click="close_dialogPreview()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>

                        <v-spacer></v-spacer>
                        <v-toolbar-items></v-toolbar-items>
                    </v-toolbar>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="8" md="10" class="mt-4">
                                <h2>Preview Confirm Return Part</h2>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="12" sm="4" md="2" class="mt-4">
                                <v-btn
                                    block
                                    small
                                    color="success"
                                    @click="save()"
                                    ><v-icon small class="mr-1"
                                        >mdi-content-save</v-icon
                                    >
                                    Save Return Part</v-btn
                                >
                            </v-col>
                            <v-col cols="12">
                                <v-simple-table class="table-inv">
                                    <template v-slot:default>
                                        <thead>
                                            <tr class="col-tr-1">
                                                <th class="text-center">
                                                    #
                                                </th>
                                                <th class="text-center">
                                                    Cso No.
                                                </th>
                                                <th class="text-center">
                                                    Date on site
                                                </th>
                                                <th class="text-center">
                                                    Ageing
                                                </th>
                                                <th class="text-center">
                                                    Description
                                                </th>
                                                <th class="text-center">
                                                    RMA No.
                                                </th>
                                                <th class="text-center">
                                                    Status Part
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="(row,
                                                index) in data_preview"
                                                :key="index"
                                            >
                                                <td>{{ index + 1 }}.</td>
                                                <td class="text-center">
                                                    {{ row.case_id }}
                                                </td>
                                                <td class="text-center">
                                                    {{ row.onsite_at }}
                                                </td>
                                                <td
                                                    v-if="row.ageing > 5"
                                                    style="color: red"
                                                    class="text-center"
                                                >
                                                    {{ row.ageing }}
                                                </td>
                                                <td v-else class="text-center">
                                                    {{ row.ageing }}
                                                </td>
                                                <td>
                                                    {{ row.part_description }}
                                                </td>
                                                <td class="text-center">
                                                    {{ row.rma }}
                                                </td>
                                                <td class="text-center">
                                                    <v-chip
                                                        small
                                                        :color="
                                                            chk_color(
                                                                row.ce_status
                                                            )
                                                        "
                                                    >
                                                        {{ row.ce_status }}
                                                    </v-chip>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import _ from "lodash"
import axios from "axios"
import { mapState, mapMutations } from "vuex"
import BarcodeReader from "../../../components/BarcodeReader"

let url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
        if (
            this.team_name === "IPG" ||
            this.team_name === "PSG" ||
            this.team_name === "ODM"
        ) {
            this.tabs_name = ["HP"]
        } else {
            this.tabs_name = ["HP", "NONHP"]
        }

        //
    },
    mounted() {
        this.get_data()
    },
    created() {
        this.change_search = _.debounce(this.change_search, 700)
    },
    computed: {
        ...mapState(["isLoading"]),
        ...mapState(["snackbar"]),
        dateRangeText() {
            this.data_search.date.sort((a, b) => {
                return new Date(a) - new Date(b)
            })

            return this.data_search.date.join(" ~ ")
        },
    },
    components: { BarcodeReader },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        ...mapMutations(["mutatesnackbar"]),
        selectswitch() {
            if (this.checkbox.length > 0) {
                this.chk = true
            } else {
                this.chk = false
            }
            if (this.checkbox_branch.length > 0) {
                this.chk_branch = true
            } else {
                this.chk_branch = false
            }
        },
        async get_data() {
            // this.mutateIsLoading()
            this.isLoadPage = true
            this.send_data.project = this.actibe_tab

            await axios
                .get(
                    url +
                        "engineer/return-part/" +
                        this.send_data.project +
                        "/" +
                        this.send_data.subproject +
                        "?page=1",
                    this.tk
                )
                .then((response) => {
                    this.isLoadPage = false
                    // this.mutateIsLoading()
                    this.checkbox = []
                    this.data_main = response.data.main
                    this.subproject = response.data.subproject
                    if (this.actibe_tab === "NONHP") {
                        this.data_main_sub = response.data.sub.data
                    }
                    this.page_total = response.data.main.last_page
                    this.page_total < 7
                        ? (this.page_count = this.page_total)
                        : (this.page_count = 7)
                })
                .catch((error) => {
                    this.mutateIsLoading()
                    console.log(error)
                })
        },
        async get_data_page(num) {
            this.current_page = num
            if (num != "...") {
                this.isLoadPage = true
                await axios
                    .get(
                        url +
                            "engineer/return-part/" +
                            this.send_data.project +
                            "/" +
                            this.send_data.subproject +
                            "?page=" +
                            num,
                        this.tk
                    )
                    .then((response) => {
                        if (this.checkbox.length == 0) {
                            this.checkbox = []
                        } else {
                            let xx = this.checkbox
                            let yy = []
                            xx.map((r) => {
                                this.checkbox = []
                                yy.push(r)
                            })
                            this.checkbox = yy
                        }
                        this.isLoadPage = false
                        this.data_main = response.data.main
                    })
            }
        },
        btn_color(n) {
            if (this.page_count == 7) {
                if (this.data_main.current_page <= 4) {
                    return this.data_main.current_page === n ? "primary" : ""
                } else if (
                    this.data_main.current_page == this.data_main.last_page
                ) {
                    return n === 7 ? "primary" : ""
                } else if (
                    this.data_main.current_page ==
                    this.data_main.last_page - 1
                ) {
                    return n === 6 ? "primary" : ""
                } else if (
                    this.data_main.current_page ==
                    this.data_main.last_page - 2
                ) {
                    return n === 5 ? "primary" : ""
                } else {
                    return n === 4 ? "primary" : ""
                }
            } else {
                return this.data_main.current_page === n ? "primary" : ""
            }
        },
        page_num_show(n) {
            let page = n
            if (this.page_count == 7) {
                let chk2 = 0
                let chk3 = 0
                let chk4 = 0
                let chk5 = 0
                let chk6 = 0
                if (this.data_main.current_page == 1) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_main.last_page - 1
                } else if (
                    this.data_main.current_page == this.data_main.last_page
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_main.last_page - 3
                    chk5 = this.data_main.last_page - 2
                    chk6 = this.data_main.last_page - 1
                } else if (this.data_main.current_page == 2) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_main.last_page - 1
                } else if (
                    this.data_main.current_page ==
                    this.data_main.last_page - 1
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_main.last_page - 3
                    chk5 = this.data_main.last_page - 2
                    chk6 = this.data_main.last_page - 1
                } else if (this.data_main.current_page == 3) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_main.last_page - 1
                } else if (
                    this.data_main.current_page ==
                    this.data_main.last_page - 2
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_main.last_page - 3
                    chk5 = this.data_main.last_page - 2
                    chk6 = this.data_main.last_page - 1
                } else {
                    chk2 = "..."
                    chk3 = this.data_main.current_page - 1
                    chk4 = this.data_main.current_page
                    chk5 = this.data_main.current_page + 1
                    chk6 = "..."
                }

                n === 1 ? (page = 1) : ""
                n === 2 ? (page = chk2) : ""
                n === 3 ? (page = chk3) : ""
                n === 4 ? (page = chk4) : ""
                n === 5 ? (page = chk5) : ""
                n === 6 ? (page = chk6) : ""
                n === 7 ? (page = this.data_main.last_page) : ""
            } else {
                n === 1 ? (page = 1) : ""
                n === 2 ? (page = 2) : ""
                n === 3 ? (page = 3) : ""
                n === 4 ? (page = 4) : ""
                n === 5 ? (page = 5) : ""
                n === 6 ? (page = 6) : ""
            }
            return page
        },
        async back() {
            this.isLoadPage = true
            let urlx = this.data_main.prev_page_url
            await axios.get(urlx, this.tk).then((response) => {
                if (this.checkbox.length == 0) {
                    this.checkbox = []
                } else {
                    let xx = this.checkbox
                    let yy = []
                    xx.map((r) => {
                        this.checkbox = []
                        yy.push(r)
                    })
                    this.checkbox = yy
                }
                this.isLoadPage = false
                this.data_main = response.data.main
            })
        },
        async next() {
            this.isLoadPage = true
            let urlx = this.data_main.next_page_url
            await axios.get(urlx, this.tk).then((response) => {
                if (this.checkbox.length == 0) {
                    this.checkbox = []
                } else {
                    let xx = this.checkbox
                    let yy = []
                    xx.map((r) => {
                        this.checkbox = []
                        yy.push(r)
                    })
                    this.checkbox = yy
                }
                this.isLoadPage = false
                this.data_main = response.data.main
            })
        },
        chk_color(status) {
            if (status === "Good") {
                return "teal accent-3"
            } else if (status === "Bad") {
                return "orange lighten-2"
            } else if (status === "DOA") {
                return "yellow accent-3"
            } else if (status === "Same Item") {
                return ""
            }
        },
        async edit(
            case_id,
            ce_status,
            part_issue_id,
            return_box_status,
            return_reason,
            return_remark,
            project_name
        ) {
            this.chk_print.ce_status = ce_status
            this.chk_print.project_name = project_name

            if (return_box_status != "") {
                this.form.box_status = return_box_status
                this.form.reason = return_reason
                this.form.remark = return_remark
            }
            await axios
                .get(url + "engineer/return-status-list/" + ce_status)
                .then((response) => {
                    this.reason = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
            this.part_issue_id = part_issue_id
            this.form.case_id = case_id
            this.dialog = true
        },
        close() {
            this.dialog = false
        },
        close2() {
            this.dialog2 = false
            // this.form2 = []
        },
        async save_one_part() {
            this.text = "Success, Your work has been saved"
            this.colorSnac = "success"
            await axios
                .post(
                    url + "engineer/save-form/" + this.part_issue_id,
                    this.form,
                    this.tk
                )
                .then((response) => {
                    if (
                        (this.chk_print.ce_status == "Good" ||
                            this.chk_print.ce_status == "DOA") &&
                        this.team_name == "INVENTORY"
                    ) {
                        if (this.chk_print.project_name == "HPE") {
                            window.open(
                                "/Document/DocDOA/" + this.part_issue_id,
                                "_blank"
                            )
                        } else {
                            window.open(
                                "/Document/DocUnused/" + this.part_issue_id,
                                "_blank"
                            )
                        }
                    }

                    this.mutatesnackbar()
                    this.close()
                    this.get_data()
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async save_form_part() {
            // console.log(this.form2)
            this.mutateIsLoading()
            let send = {
                parts: this.form2,
            }
            this.text = "Success, Your work has been saved"
            this.colorSnac = "success"

            await axios
                .post(url + "engineer/save-form-search/", send, this.tk)
                .then((response) => {
                    this.mutatesnackbar()
                    this.form_search.search = ""
                    this.close2()

                    this.form2.map((r, i) => {
                        if (
                            (this.checkbox.includes(r.part_issue_id) == false &&
                                r.status != "rejected") ||
                            r.return_confirm == "new"
                        ) {
                            this.checkbox.push(r.part_issue_id)
                        }
                    })

                    this.get_data_page(this.current_page)
                    this.mutateIsLoading()
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async save() {
            let save
            // console.log(this.chk)
            // console.log(this.chk_branch)

            if (this.chk_branch === true) {
                save = {
                    part_issue_id: this.checkbox_branch,
                }
            } else {
                save = {
                    part_issue_id: this.checkbox,
                }
            }

            // console.log(save)

            this.text = "Success, Your work has been saved"
            this.colorSnac = "success"
            this.mutateIsLoading()
            await axios
                .post(url + "engineer/save-return-part/", save, this.tk)
                .then((response) => {
                    this.mutateIsLoading()
                    this.mutatesnackbar()
                    this.dialogPreview = false
                    if (this.actibe_tab === "HP") {
                        this.$router.push(
                            "/Document/DocReturn-hp/" + response.data.return_no
                        )
                    } else {
                        this.$router.push(
                            "/Document/DocReturn-nonhp/" +
                                response.data.return_no
                        )
                    }
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 1500)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        gen_barcode(result) {
            if (this.chk_action === false) {
                this.form_search.search = result
                this.change_search()
            }
        },
        reset() {
            if (this.actibe_tab === "HP") {
                this.form_search.filter = "RMA"
            } else {
                this.form_search.filter = "SinglePart"
            }
            this.form_search.search = ""
            this.checkbox = []
            // this.get_data()
        },
        all() {
            if (this.chk === true) {
                this.chk = false
                this.colorx = ""
                this.checkbox = []
            } else {
                this.chk = true
                this.colorx = "success"
                this.data_main.data.map((r) => {
                    if (r.ce_status === "DOA" || r.ce_status === "Good") {
                        if (r.return_box_status != null) {
                            this.checkbox.push(r.part_issue_id)
                        }
                    } else {
                        this.checkbox.push(r.part_issue_id)
                    }
                })
            }
        },
        all_nonhp(r) {
            if (r === 1) {
                //clear ก่อนเพราะ save ได้ทีะเมนู
                this.checkbox_branch = []
                this.colorx_branch = ""
                this.chk_branch = false
                if (this.chk === true) {
                    this.chk = false
                    this.colorx = ""
                    this.checkbox = []
                } else {
                    this.chk = true
                    this.colorx = "success"
                    this.data_main.data.map((r) => {
                        this.checkbox.push(r.part_issue_id)
                    })
                }
            } else {
                //clear ก่อนเพราะ save ได้ทีะเมนู
                this.checkbox = []
                this.colorx = ""
                this.chk = false
                if (this.chk_branch === true) {
                    this.chk_branch = false
                    this.colorx_branch = ""
                    this.checkbox_branch = []
                } else {
                    this.chk_branch = true
                    this.colorx_branch = "success"
                    this.data_main_sub.map((r) => {
                        this.checkbox_branch.push(r.part_issue_id)
                    })
                }
            }
        },
        async print_part(part_issue_id) {
            // let routeData = this.$router.resolve({
            //   path: "/Document/DocUnused/" + part_issue_id,
            //   // query: { data: "someData" },
            // });
            // console.log(routeData);
            // console.log(part_issue_id);
            // window.open(routeData, "_blank");
            this.$router.push("/Document/DocUnused/" + part_issue_id)
        },
        async change_search() {
            if (this.form_search.search != "") {
                this.chk_action = true
                this.mutateIsLoading()
                await axios
                    .post(
                        url + "engineer/check-return-part",
                        this.form_search,
                        this.tk
                    )
                    .then((response) => {
                        // console.log("-change_search", response)
                        if (response.data.error != undefined) {
                            this.mutateIsLoading()
                            this.text = response.data.error
                            this.colorSnac = "error"

                            this.$swal(response.data.error, {
                                title: this.form_search.search,
                                icon: "warning",
                                button: false,
                                timer: 2000,
                            })

                            setTimeout(() => {
                                this.chk_action = false
                            }, 2000)
                        } else {
                            this.mutateIsLoading()
                            this.form_data = response.data
                            let x = true
                            // console.log("--x")
                            response.data.map((row, index) => {
                                if (
                                    row.ce_status == "Good" ||
                                    row.ce_status == "DOA" ||
                                    row.status == "rejected"
                                ) {
                                    this.dialog2 = true

                                    this.$set(this.form2, index, {
                                        box_status: row.return_box_status,
                                        reason: row.return_reason,
                                        remark: row.return_remark,
                                        part_issue_id: row.part_issue_id,
                                        ce_status: row.ce_status,
                                        status: row.status,
                                        return_confirm: "",
                                    })
                                    x = false
                                } else {
                                    if (
                                        this.checkbox.includes(
                                            row.part_issue_id
                                        ) == false
                                    ) {
                                        this.checkbox.push(row.part_issue_id)
                                    }
                                }
                            })

                            if (x == true) {
                                this.$swal("Successful Search", {
                                    title: this.form_search.search,
                                    icon: "success",
                                    button: false,
                                    timer: 2000,
                                })
                                this.form_search.search = ""
                                this.chk_action = false
                                // this.$swal({
                                //     title: "Successful Search",
                                //     text: this.form_search.search,
                                //     icon: "success",

                                //     buttons: {
                                //         cancel: true,
                                //         text: "ค้นหา Part ถัดไป",
                                //     },
                                // }).then((conf) => {
                                //     if (conf) {
                                //     } else {
                                //         this.chk_action = false
                                //     }

                                //     this.form_search.search = ""
                                //     this.chk_action = false

                                //     // this.checkbox = [
                                //     //     ...this.checkbox,
                                //     //     ...row.part_issue_id,
                                //     // ]
                                // })
                            }
                            // this.dialog = true
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
        chk_chkeckbox(pj, ce_status, return_box_status) {
            console.log(pj, ce_status, return_box_status)
            if ((ce_status === "DOA" || ce_status === "Good") && pj == "CDAX") {
                if (return_box_status === null) {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        },
        change_tab(change_tab) {
            this.chk = false
            this.colorx = ""
            this.checkbox = []
            this.checkbox_branch = []
            this.data_main = []
            this.actibe_tab = change_tab
            if (this.actibe_tab === "HP") {
                this.form_search.filter = "RMA"
            } else {
                this.data_main_sub = []
                this.form_search.filter = "SinglePart"
            }
            this.get_data()
        },
        get_date() {
            if (this.dateRangeText.length === 23) {
                this.modal = false
            }
        },
        async get_history() {
            this.actibe_tab === "HP"
                ? (this.DocReturn_url = "/Document/DocReturn-hp/")
                : (this.DocReturn_url = "/Document/DocReturn-nonhp/")
            console.log(this.data_search)

            this.mutateIsLoading()
            await axios
                .post(
                    url + "engineer/return-part/history",
                    this.data_search,
                    this.tk
                )
                .then((response) => {
                    this.data_history = response.data
                    // console.log(response)
                    this.mutateIsLoading()
                    if (this.dialog_search === false) {
                        this.dialog_search = true
                    }
                })
                .catch((error) => {
                    console.log(error)
                    this.mutateIsLoading()
                })
        },
        async get_dialogPreview() {
            if (this.checkbox.length > 0) {
                this.mutateIsLoading()
                let send = {
                    part_issue_id: this.checkbox,
                }
                await axios
                    .post(url + "engineer/preview-return-part", send, this.tk)
                    .then((response) => {
                        this.data_preview = response.data
                        this.dialogPreview = true
                        this.mutateIsLoading()
                    })
                    .catch((error) => {
                        console.log(error)
                        this.mutateIsLoading()
                    })
            }
        },
        close_dialogPreview() {
            this.data_preview = []
            this.dialogPreview = false
        },
        async export_data() {
            this.chk_export_data = true
            await axios({
                url: url + "engineer/return-part/export/",
                method: "POST",
                responseType: "blob",
                data: this.data_search,
                headers: { Authorization: "Bearer " + localStorage.token },
            }).then((response) => {
                this.chk_export_data = false
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "file.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
            })
        },
        async export_data2() {
            this.chk_export_data = true
            await axios({
                url:
                    url +
                    "engineer/return-part-export/" +
                    this.send_data.project +
                    "/" +
                    this.send_data.subproject,
                method: "GET",
                responseType: "blob",
                headers: { Authorization: "Bearer " + localStorage.token },
            }).then((response) => {
                this.chk_export_data = false
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "file.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
            })
        },
    },

    data() {
        return {
            chk_export_data: false,
            DocReturn_url: null,
            tab: null,
            data_main: [],
            data_main_sub: [],
            checkbox: [],
            checkbox_branch: [],
            form_search: {
                filter: "RMA",
                search: "",
            },
            form: {
                reason: "",
            },
            form_data: [],
            valid: false,
            text: "",
            colorSnac: "",
            dialog: false,
            form: {
                reason: "",
            },
            box_statusR: [(v) => !!v || "Box Status is required"],
            reasonR: [(v) => !!v || "Reason is required"],
            remarkR: [(v) => !!v || "Remark is required"],
            return_confirmR: [(v) => !!v || "return confirm is required"],
            box: [
                {
                    id: "new",
                    name: "เปิดกล่องใหม่",
                },
                {
                    id: "used",
                    name: "เปิดกล่องที่ใช้มาก่อน",
                },
            ],
            return_confirm_item: [
                {
                    id: "edit",
                    name: "แก้ไขข้อมูลการคืน Part",
                },
                {
                    id: "new",
                    name: "คืน Part ขิ้นนี้มใหม่อีกครั้ง",
                },
            ],
            reason: [],
            part_issue_id: 0,
            select_list: ["Case ID", "RMA", "PO Number"],
            select_list2: ["Case ID", "SinglePart"],
            chk: false,
            chk_branch: false,
            colorx: "",
            colorx_branch: "",
            tk: null,
            chk_action: false,
            actibe_tab: "HP",
            tabs_name: [],
            direction: "right",
            team_name: localStorage.team_name,
            dialog_search: false,
            data_search: {
                search: null,
                date: [],
            },
            modal: false,
            data_history: [],
            subproject: [],
            send_data: {
                project: "",
                subproject: "all",
            },
            page: 1,
            page_total: 0,
            page_count: 0,
            chk_num_page: 0,
            dialog2: false,
            valid2: false,
            isLoadPage: false,
            form2: [],
            dialogPreview: false,
            data_preview: [],
            chk_print: {
                ce_status: "",
                project_name: "",
            },
        }
    },
}
</script>
